import axios from "axios";
import React, { Component } from "react";
import {Container, Col, Row, Image } from "react-bootstrap";

export class Navigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            liveIsActive: false,
            liveLink: null,
            auctionIsActive: false,
            auctionLink: null,
            recentNewsCount: null,
            all_links: [],
            suggestions: [],
        };
    }

    componentDidMount() {
        this.collectLinks();
        (async () => {
            await this.getLiveLink();
            await this.getActiveAuction();
            await this.getRecentNewsCount();
        })();
    }

    getLiveLink = async () => {
        const result = await axios
            .post(
                process.env.REACT_APP_API_URL +
                    process.env.REACT_APP_GET_LIVE_LINK,
                {
                    apiKey: process.env.REACT_APP_API_PUBLIC_TOKEN
                }
            );

        const link = result.data.result.data.link;

        if (link) {
            this.setState({
                liveIsActive: true,
                liveLink: link,
            });
        }
        return result;
    }

    getActiveAuction = async () => {
        const result = await axios
            .post(
                process.env.REACT_APP_API_URL +
                    process.env.REACT_APP_GET_ACTIVE_AUCTION,
                {
                    apiKey: process.env.REACT_APP_API_PUBLIC_TOKEN
                }
            );

        const active_auctions = result.data.result.data.active_auctions;

        if (active_auctions > 0) {
            this.setState({
                auctionIsActive: true,
                auctionLink: "/auctions/active",
            });
        }
        return result;
    }

    getRecentNewsCount = async () => {
        const result = await axios
            .post(
                process.env.REACT_APP_API_URL +
                process.env.REACT_APP_GET_NEWS_COUNT_PATH +
                '14.json',
                {
                    apiKey: process.env.REACT_APP_API_PUBLIC_TOKEN
                }
            );

        const recentNewsCount = result.data.result.data.newsCount;

        if (recentNewsCount) {
            this.setState({
                recentNewsCount
            });
        }
    }

    collectLinks = () => {
        const all_links = Array.from(document.querySelectorAll("a"))
            .map(link => ({ title: link.textContent, url: link.href}));

        this.setState({ all_links });
    };

    handleSearch = (e) => {
        this.setState({ suggestions: [] });
        const value = e.target.value;
        if (value) {
            const suggestions = this.state.all_links.filter(link => link.title.toLowerCase().includes(value.toLowerCase()));
            this.setState({ suggestions });
        }
    };

    render() {
        return (
            <div>
                <div id="navi" className="topnav">
                    <Container>
                        {this.state.liveIsActive || this.state.auctionIsActive
                            ? <div className='logo-container'>
                                <div className="logo icon-img-70 drop-shadow logo-animate">
                                    <a href={"/"}>
                                        <Image src={process.env.REACT_APP_BASE_URL + "/images/logo/logo.png"} alt="logo"/>
                                    </a>
                                </div>
                                {this.state.liveIsActive
                                    ? <div className="logo icon-img-120 live-link">
                                        <a href={this.state.liveLink} target='_blank'>
                                            <span><i className="fa fa-play-circle" style={{color: 'red'}}> </i>  پخش زنده مزایده</span>
                                        </a>
                                     </div>
                                    : <div className="logo icon-img-120 live-link">
                                        <a href={this.state.auctionLink} target='_blank'>
                                            <span><i className="fa fa-info-circle" style={{color: 'red'}}> </i>  مزایده املاک</span>
                                        </a>
                                    </div>}

                            </div>
                            : <div className="logo icon-img-70 drop-shadow">
                                <a href={"/"}>
                                    <Image src={process.env.REACT_APP_BASE_URL + "/images/logo/logo.png"} alt="logo"/>
                                </a>
                            </div>}

                        <div className="menu-icon cursor-pointer">
                            <span className="icon">
                                <i> </i>
                                <i> </i>
                            </span>
                            <span className="text"><span className="word">منو</span></span>
                        </div>
                    </Container>
                </div>

                <div className="hamenu">
                    <Container>
                        <Row>
                            <Col lg={2}>
                                <div className="menu-text">
                                    <div className="text">
                                        <h2>توسعه پایدار ایرانیان</h2>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={7} className="padding-rl-30">
                                <div className="menu-links">
                                    <ul className="main-menu rest">
                                        <li>
                                            <div className="o-hidden">
                                                <div className="link cursor-pointer dmenu">
                                                    <span className="fill-text" data-text="معرفی شرکت">معرفی شرکت</span>
                                                    <i> </i>
                                                </div>
                                            </div>
                                            <div className="sub-menu">
                                                <ul>
                                                    <li>
                                                        <a href={"/pages/about-us"} className="sub-link">درباره ما</a>
                                                    </li>
                                                    <li>
                                                        <a href={"/pages/pillars"} className="sub-link">ارکان جهت ساز</a>
                                                    </li>
                                                    <li>
                                                        <a href={"/pages/structure"} className="sub-link">ساختار سازمانی</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="o-hidden">
                                                <div className="link cursor-pointer dmenu">
                                                    <span className="fill-text" data-text="مزایده‌ و فروش املاک">مزایده‌ و فروش املاک</span>
                                                    <i> </i>
                                                </div>
                                            </div>
                                            <div className="sub-menu">
                                                <ul>
                                                    <li>
                                                        <a href={"/auctions/active"} className="sub-link">مزایده‌های جاری</a>
                                                    </li>
                                                    <li>
                                                        <a href={"/auctions/archive"} className="sub-link">مزایده‌های پیشین</a>
                                                    </li>
                                                    <li>
                                                        <a href={'/estates'} className="sub-link">معرفی کلیه املاک قابل فروش</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="o-hidden">
                                                <div className="link cursor-pointer dmenu">
                                                    <span className="fill-text" data-text="پروژه‌های ساختمانی">پروژه‌های ساختمانی</span>
                                                    <i> </i>
                                                </div>
                                            </div>
                                            <div className="sub-menu">
                                                <ul>
                                                    <li>
                                                        <a href={'/projects/under-construction'} className="sub-link">پروژه‌های فعال</a>
                                                    </li>
                                                    <li>
                                                        <a href={'/projects/completed'} className="sub-link">پروژه‌های اتمام یافته</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="o-hidden">
                                                <div className="link cursor-pointer dmenu">
                                                    <span className="fill-text" data-text="بازساری و بهسازی">بازسازی و بهسازی</span>
                                                    <i> </i>
                                                </div>
                                            </div>
                                            <div className="sub-menu">
                                                <ul>
                                                    <li>
                                                        <a href={'/renovations/under-construction'} className="sub-link">پروژه‌های فعال</a>
                                                    </li>
                                                    <li>
                                                        <a href={'/renovations/completed'} className="sub-link">پروژه‌های اتمام یافته</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="o-hidden">
                                                <a href={"/pages/news"} className="link">
                                                    <span data-badge="100" className="fill-text" data-text="اخبار">
                                                        {this.state.recentNewsCount
                                                            ? <span className='notification-badge'>{this.state.recentNewsCount}</span>
                                                            : ''}
                                                        اخبار
                                                    </span>
                                                </a>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="o-hidden">
                                                <div className="link cursor-pointer dmenu">
                                                    <span className="fill-text" data-text="سامانه‌های الکترونیکی">سامانه‌های الکترونیکی</span>
                                                    <i> </i>
                                                </div>
                                            </div>
                                            <div className="sub-menu">
                                                <ul>
                                                    <li>
                                                        <a href="https://chargoon.paidariranian.ir/" target="_blank" className="sub-link">سامانه اداری</a>
                                                    </li>
                                                    <li>
                                                        <a href={process.env.REACT_APP_API_URL + "/admin"} target="_blank" className="sub-link">سامانه ما (مدیریت املاک)</a>
                                                    </li>
                                                    <li>
                                                        <a href={process.env.REACT_APP_API_URL + "/login"} target="_blank" className="sub-link">سامانه مشتریان</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="o-hidden">
                                                <a href={"/pages/contact-us"} className="link">
                                                    <span className="fill-text" data-text="تماس با ما">تماس با ما</span>
                                                </a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                            <Col lg={3} className="d-flex align-items-end">
                                <div className="cont-info full-width">
                                    <div className="item">
                                        <h6 className="mb-15">در تماس باشید</h6>
                                        <p>تهران، بزرگ‌راه حکیم شرق بعد از بزرگ‌راه ستاری، خروجی بهنام، جنب ایستگاه مترو شهید ستاری، پلاک یک - کدپستی: ۱۴۷۱۸۵۵۱۱۰</p>
                                        <Row>
                                            <Col lg={6}>
                                                <p className="underline main-color mt-5 mb-5"><a href="tel:02142607000">021-42607000</a>
                                                </p>
                                                <p><a href="mailto:info@paidariranian.ir" className="link">info@paidariranian.ir</a></p>
                                                <ul className="rest social-text d-flex mt-5 fz-13">
                                                    <li className="mr-5">
                                                        <a href="https://www.linkedin.com/company/%D8%B3%D8%B1%D9%85%D8%A7%DB%8C%D9%87-%DA%AF%D8%B0%D8%A7%D8%B1%DB%8C-%D8%B9%D9%85%D8%B1%D8%A7%D9%86-%D9%88-%D8%AA%D9%88%D8%B3%D8%B9%D9%87-%D9%BE%D8%A7%DB%8C%D8%AF%D8%A7%D8%B1-%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C%D8%A7%D9%86" className="hover-this">
                                                <span className="hover-anim">
                                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
                                                        <path fill="#0078d4" d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5	V37z"> </path>
                                                        <path d="M30,37V26.901c0-1.689-0.819-2.698-2.192-2.698c-0.815,0-1.414,0.459-1.779,1.364	c-0.017,0.064-0.041,0.325-0.031,1.114L26,37h-7V18h7v1.061C27.022,18.356,28.275,18,29.738,18c4.547,0,7.261,3.093,7.261,8.274	L37,37H30z M11,37V18h3.457C12.454,18,11,16.528,11,14.499C11,12.472,12.478,11,14.514,11c2.012,0,3.445,1.431,3.486,3.479	C18,16.523,16.521,18,14.485,18H18v19H11z" opacity=".05"> </path>
                                                        <path d="M30.5,36.5v-9.599c0-1.973-1.031-3.198-2.692-3.198c-1.295,0-1.935,0.912-2.243,1.677	c-0.082,0.199-0.071,0.989-0.067,1.326L25.5,36.5h-6v-18h6v1.638c0.795-0.823,2.075-1.638,4.238-1.638	c4.233,0,6.761,2.906,6.761,7.774L36.5,36.5H30.5z M11.5,36.5v-18h6v18H11.5z M14.457,17.5c-1.713,0-2.957-1.262-2.957-3.001	c0-1.738,1.268-2.999,3.014-2.999c1.724,0,2.951,1.229,2.986,2.989c0,1.749-1.268,3.011-3.015,3.011H14.457z" opacity=".07"> </path>
                                                        <path fill="#fff" d="M12,19h5v17h-5V19z M14.485,17h-0.028C12.965,17,12,15.888,12,14.499C12,13.08,12.995,12,14.514,12	c1.521,0,2.458,1.08,2.486,2.499C17,15.887,16.035,17,14.485,17z M36,36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698	c-1.501,0-2.313,1.012-2.707,1.99C24.957,25.543,25,26.511,25,27v9h-5V19h5v2.616C25.721,20.5,26.85,19,29.738,19	c3.578,0,6.261,2.25,6.261,7.274L36,36L36,36z"> </path>
                                                    </svg>
                                                </span>
                                                        </a>
                                                    </li>
                                                    <li className="mr-5">
                                                        <a href="https://instagram.com/enotpi?igshid=6dubtjusjp6j" className="hover-this">
                                                <span className="hover-anim">
                                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
                                                        <radialGradient id="yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1" cx="19.38" cy="42.035" r="44.899" gradientUnits="userSpaceOnUse">
                                                            <stop offset="0" stopColor="#fd5"> </stop>
                                                            <stop offset=".328" stopColor="#ff543f"> </stop>
                                                            <stop offset=".348" stopColor="#fc5245"> </stop>
                                                            <stop offset=".504" stopColor="#e64771"> </stop>
                                                            <stop offset=".643" stopColor="#d53e91"> </stop>
                                                            <stop offset=".761" stopColor="#cc39a4"> </stop>
                                                            <stop offset=".841" stopColor="#c837ab"> </stop>
                                                        </radialGradient>
                                                        <path fill="url(#yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1)" d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"> </path>
                                                        <radialGradient id="yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2" cx="11.786" cy="5.54" r="29.813" gradientTransform="matrix(1 0 0 .6663 0 1.849)" gradientUnits="userSpaceOnUse">
                                                            <stop offset="0" stopColor="#4168c9"> </stop>
                                                            <stop offset=".999" stopColor="#4168c9" stopOpacity="0"> </stop>
                                                        </radialGradient>
                                                        <path fill="url(#yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2)" d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"> </path>
                                                        <path fill="#fff" d="M24,31c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7S27.859,31,24,31z M24,19c-2.757,0-5,2.243-5,5	s2.243,5,5,5s5-2.243,5-5S26.757,19,24,19z"> </path>
                                                        <circle cx="31.5" cy="16.5" r="1.5" fill="#fff"> </circle>
                                                        <path fill="#fff" d="M30,37H18c-3.859,0-7-3.14-7-7V18c0-3.86,3.141-7,7-7h12c3.859,0,7,3.14,7,7v12	C37,33.86,33.859,37,30,37z M18,13c-2.757,0-5,2.243-5,5v12c0,2.757,2.243,5,5,5h12c2.757,0,5-2.243,5-5V18c0-2.757-2.243-5-5-5H18z"> </path>
                                                    </svg>
                                                </span>
                                                        </a>
                                                    </li>
                                                    <li className="mr-5">
                                                        <a href="https://t.me/enotpi" className="hover-this">
                                                <span className="hover-anim">
                                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
                                                        <path fill="#29b6f6" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"> </path>
                                                        <path fill="#fff" d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z"> </path>
                                                        <path fill="#b0bec5" d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z"> </path>
                                                        <path fill="#cfd8dc" d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z"> </path>
                                                    </svg>
                                                </span>
                                                        </a>
                                                    </li>
                                                    <li className="mr-5">
                                                        <a href="https://www.aparat.com/enotpi" className="hover-this">
                                                <span className="hover-anim">
                                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
                                                        <path fill="#263238" d="M21.881 6.136l-4.315-.974c-3.52-.795-7.017 1.414-7.812 4.934l-.983 4.351C11.603 9.95 16.357 6.788 21.881 6.136zM6.136 26.119l-.974 4.315c-.795 3.52 1.414 7.017 4.934 7.812l4.351.983C9.95 36.396 6.788 31.643 6.136 26.119zM37.904 9.754l-4.351-.983c4.497 2.832 7.659 7.586 8.311 13.109l.974-4.315C43.633 14.047 41.424 10.549 37.904 9.754zM26.119 41.864l4.315.974c3.52.795 7.017-1.414 7.812-4.934l.983-4.351C36.397 38.05 31.643 41.212 26.119 41.864z"> </path>
                                                        <path fill="#e91e63" d="M24,8C15.163,8,8,15.163,8,24s7.163,16,16,16s16-7.163,16-16S32.837,8,24,8z M20,13 c2.209,0,4,1.791,4,4c0,2.209-1.791,4-4,4s-4-1.791-4-4C16,14.791,17.791,13,20,13z M17,32c-2.209,0-4-1.791-4-4 c0-2.209,1.791-4,4-4s4,1.791,4,4C21,30.209,19.209,32,17,32z M22,24c0-1.105,0.895-2,2-2s2,0.895,2,2c0,1.105-0.895,2-2,2 S22,25.105,22,24z M28,35c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C32,33.209,30.209,35,28,35z M31,24 c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C35,22.209,33.209,24,31,24z"> </path>
                                                    </svg>
                                                </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </Col>
                                            <Col lg={6}>
                                                <ul className="rest social-text d-flex fz-13">
                                                    <li>
                                                        <a referrerPolicy='origin' target='_blank'
                                                           href='https://trustseal.enamad.ir/?id=525189&Code=9DJFccWGkV7EmDxrO4ahpywZ2iBuXSgv'>
                                                            <img
                                                                referrerPolicy='origin'
                                                                src='https://trustseal.enamad.ir/logo.aspx?id=525189&Code=9DJFccWGkV7EmDxrO4ahpywZ2iBuXSgv'
                                                                alt='' style={{cursor: 'pointer'}}
                                                                code='9DJFccWGkV7EmDxrO4ahpywZ2iBuXSgv'/>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="search-form">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                name="search"
                                                placeholder="جستجو"
                                                onChange={this.handleSearch}
                                            />
                                            <button><span className="pe-7s-search"> </span></button>
                                            {/* Suggestions section */}
                                            {this.state.suggestions.length >= 1 && <div className="ml-auto">
                                                <div className="search-suggestions">
                                                    <ul className="select-options ml-15 mr-15">
                                                        {Object.values(this.state.suggestions).map((value, key) => (
                                                            <li key={key}>
                                                                <a href={value.url} style={{display: 'list-item'}}>{value.title}</a>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>}{/* End of Suggestions section */}
                                        </div>
                                    </div>

                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        );
    }
}
